import React, { Component } from 'react';
import Style from '../licenseManagement.module.css';
import { connect } from 'react-redux';
import { getLmUsers, getUserStats, selectUsr } from '../../store/entities/lmDevicesUsers';
import EnterIcon from '../../assets/Enter_Arrow_Right.svg';
import { formatDetectionDatetime } from '../../utilities/datetime'
import LoaderWrapper from '../common/LoaderWrapper/LoaderWrapper';
import { isGlobalView } from '../../utilities/config';
import SelectBox from '../common/selectbox/selectBox';
import searchIcon from '../../assets/magnifier.svg';
import Tooltip from '../common/popover/tooltip';
import Paginator from '../common/paginator/paginator'


const SORT_BY_OPTIONS = {
    created: {fieldName: 'CreatedOn', displayName: 'Created Date', abrev: 'crtOn'},
    name: {fieldName: 'UserIdentifier', displayName: 'User Name', abrev: 'usrNm'},
    default: {fieldName: 'CreatedOn', displayName: 'Created Date', abrev: 'crtOn'},
}

const SORT_BY_DIRECTIONS = {
    asc: {displayName: 'Ascending', abrev: 'asc'},
    desc: {displayName: 'Descending', abrev: 'desc'},
    default: {displayName: 'Descending', abrev: 'desc'},
}

class UserTab extends Component {

    state = {
        userSearchText: '',
        userStatusFilter: 'all',
        userSortField: SORT_BY_OPTIONS.default.fieldName,
        userSortDir: SORT_BY_DIRECTIONS.default.abrev,
        customerChanged: false,
        userFilters: {
            pageNo: 1,
            pageSize: 5,
            searchTerm: '',
            isActive: null,
            sortBy: `${SORT_BY_OPTIONS.default.abrev}|${SORT_BY_DIRECTIONS.default.abrev}`,
        }
    }

    componentDidMount = () => {
        if (this.props.location && this.props.location.state && this.props.location.state.tab) {
            this.setState({ selectedTab: this.props.location.state.tab });
        }

        if (this.props.selectedCustomer) {
            this.populateUserData();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const prevSelectedCustomerId = prevProps.selectedCustomer && prevProps.selectedCustomer.id;  
        const currentSelectedCustomerId = this.props.selectedCustomer && this.props.selectedCustomer.id;  

        const prevMatchId = prevProps.matchParams && prevProps.matchParams.id;  
        const currentMatchId = this.props.matchParams && this.props.matchParams.id;  

        const customerChanged = prevSelectedCustomerId !== currentSelectedCustomerId && !!currentSelectedCustomerId;  
        const routeChanged = prevMatchId !== currentMatchId && !!currentMatchId;  

        if (customerChanged || routeChanged) {  
            this.populateUserData();  
        }  
    }

    populateUserData = () => {
        if(this.props.selectedCustomer) {
            const selectedId = this.props.matchParams.id;
            const defaultCustomerId = this.props.selectedCustomer?.defaultCustomerId;
            const globalView = isGlobalView(this.props.selectedCustomer?.organizationName);
            this.props.getUserStats(selectedId, defaultCustomerId, globalView);
            this.props.getLmUsers(this.getUserFilters(this.state.userFilters), selectedId, defaultCustomerId, globalView);
        }
    }

    getUserFilters = (filters) => {
        return Object.fromEntries(
            Object.entries({...filters, pageSize: filters.pageSize + 1}).filter(([_, v]) => v != null)
        );
    }

    onUserActionClick = (row) => {
        const customerId = this.props.selectedCustomer?.id || this.props.matchParams.id;
        if (!isGlobalView(this.props.selectedCustomer?.organizationName)) {
            this.props.history.push(`/customers/${customerId}/user/${row.userId}`);
        }
        else {
            this.props.history.push(`/tenants/${customerId}/${row.CustomerId}/user/${row.userId}`);
        }
        this.props.selectUsr(row);
    }

    usersGridDef = {
        name: 'userList',
        columns: [
            { fieldName: 'UserIdentifier', displayName: 'User Email / Profile', width: '30%', className: Style.boldFont },
            { fieldName: 'CreatedOn', displayName: 'Detail', dataType: 'date', subType: 'datetime', prefix: 'Created At', width: '30%', className: Style.boldFont },
            { fieldName: 'isActive', displayName: 'Status', dataType: 'boolean', trueValue: 'Active', falseValue: 'Inactive', width: '30%', className: Style.boldFont },
            { fieldName: 'action', displayName: 'Action', dataType: 'image', src: EnterIcon, width: '50px', onClick: this.onUserActionClick, className: Style.boldFont }
        ]
    }

    getFilteredUsers = ({ resetPage = false } = {}) => {
        const { userSearchText, userStatusFilter, userSortField, userSortDir } = this.state;
        const selectedId = this.props.matchParams.id;
        const defaultCustomerId = this.props.selectedCustomer?.defaultCustomerId;
        const globalView = isGlobalView(this.props.selectedCustomer?.organizationName);
        const isActiveFilter = userStatusFilter === 'all' ? null : userStatusFilter === 'active';
        const sortBy = `${SORT_BY_OPTIONS[userSortField]?.abrev || SORT_BY_OPTIONS.default.abrev}|${SORT_BY_DIRECTIONS[userSortDir]?.abrev || SORT_BY_DIRECTIONS.default.abrev}`;
        const pageNo = resetPage ? 1 : (this.state.userFilters?.pageNo || 1);
        if (resetPage) {
            this.setState(s => ({ userFilters: { ...s.userFilters, pageNo: 1 } }));
        }
        const filters = {
            pageNo,
            pageSize: this.state.userFilters?.pageSize || 5,
            searchTerm: userSearchText,
            isActive: isActiveFilter,
            sortBy,
        };
        this.props.getLmUsers(this.getUserFilters(filters), selectedId, defaultCustomerId, globalView);
    }

    _userSearchTimer = null;

    handleUserSearch = (searchTerm) => {
        this.setState({ userSearchText: searchTerm });
        if (this._userSearchTimer) clearTimeout(this._userSearchTimer);
        this._userSearchTimer = setTimeout(() => {
            this.setState(
                s => ({ userFilters: { ...s.userFilters, pageNo: 1 } }),
                () => this.getFilteredUsers({resetPage: true})
            );
        }, 300);
    }

    handleUserSelect = (selectedOption) => {
        if (selectedOption && selectedOption.id && selectedOption.id !== 'all') {
            this.setState({ userSearchText: selectedOption.name || '' }, () => this.getFilteredUsers({ resetPage: true }));
        } else {
            this.setState({ userSearchText: '' }, () => this.getFilteredUsers({ resetPage: true }));
        }
    }

    handleCustomerChange = () => {
        this.setState({ customerChanged: false });
    }

    formatUsersForSelectBox = () => {
        return this.props.users?.length > 0 ? this.props.users.map(user => ({
            name: user.UserIdentifier || user.userId,
            id: user.userId
        })) : [];
    }

    loadNextUsers = () => {
        if(this.props.isUsersLastPage) {
            return;
        }
        let nextPageNo = this.state.userFilters.pageNo + 1;
        this.setState(() => ({ userFilters: { ...this.state.userFilters, pageNo: nextPageNo } }), this.getFilteredUsers);
    }

    loadPrevUsers = () => {
        let prevPageNo = Math.max(this.state.userFilters.pageNo - 1, 1);
        this.setState(() => ({ userFilters: { ...this.state.userFilters, pageNo: prevPageNo } }), this.getFilteredUsers);
    }

    render() {

        return (
        <>
            <div className={`${Style.workArea}`}>
            <div className={`${Style.headerContiner} mt-1 p-4 px-5 d-flex`} style={{ height: 'auto', minHeight: '131px' }}>
                <div className={`${Style.borderStyle} pl-3 pr-5`}>
                <div className={`${Style.activeUsersFontStyle}`}>Total Users</div>
                <div className={`${Style.countStyle}`}>
                    {this.props.userStatsLoading
                    ? <LoaderWrapper loading={true} waitForData={false} styles={{ minHeight: '60px'}} isFlex={true} />
                    : this.props.userStats?.ttlUsrCnt || 0}
                </div>
                </div>
                <div className={`${Style.borderStyle} pl-3 pr-5`}>
                <div className={`${Style.activeUsersFontStyle}`}>Active Users</div>
                <div className={`${Style.countStyle}`}>
                    {this.props.userStatsLoading
                    ? <LoaderWrapper loading={true} waitForData={false} styles={{ minHeight: '60px'}} isFlex={true} />
                    : this.props.userStats?.actUsrCnt || 0}
                </div>
                </div>
            </div>
            </div>

            <div className={`${Style.workArea} mt-2`}>
            <div className={`${Style.userLicenses}`}>User List</div>
            <div className={`mt-2 ${Style.pixmFilterBar} d-flex align-items-center px-3`}>
                <SelectBox
                    role="CustomerAdmin,PixmAdmin,TenantAdmin"
                    width="20%"
                    optionBoxWidth="300px"
                    source="UserTab"
                    options={[...[{ name: 'User: All', id: 'all' }], ...this.formatUsersForSelectBox()]}
                    defaultOption={{ name: 'User: All', id: 'all' }}
                    onSelect={this.handleUserSelect}
                    onSearch={this.handleUserSearch}
                    icon={searchIcon}
                    customerChanged={this.state.customerChanged}
                    handleCustomerChange={this.handleCustomerChange}
                    type="lmusers"
                    showSearch={true}
                    minLengthToSearch={2}
                />
                <div className="d-flex align-items-center ml-3">
                {['all', 'active', 'inactive'].map(status => (
                    <button
                    key={status}
                    onClick={() => this.setState({ userStatusFilter: status }, () => this.getFilteredUsers({ resetPage: true }))}
                    style={{
                        marginLeft: '6px',
                        padding: '5px 14px',
                        borderRadius: '5px',
                        border: '1px solid #e3e3e3',
                        fontFamily: 'Roboto',
                        fontSize: '13px',
                        cursor: 'pointer',
                        backgroundColor: this.state.userStatusFilter === status ? '#6eb0e1' : '#f7f7f7',
                        color: this.state.userStatusFilter === status ? '#fff' : '#333',
                        fontWeight: this.state.userStatusFilter === status ? 'bold' : 'normal',
                    }}
                    >
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                    </button>
                ))}
                </div>
                <div className="d-flex align-items-center ml-4">
                <span style={{ fontFamily: 'Roboto', fontSize: '13px', color: '#333', marginRight: '8px' }}>Sort by:</span>
                <select
                    value={this.state.userSortField}
                    onChange={(e) => this.setState({ userSortField: e.target.value }, () => this.getFilteredUsers({ resetPage: true }))}
                    style={{ height: '34px', borderRadius: '5px', border: '1px solid #e3e3e3', padding: '0 8px', fontFamily: 'Roboto', fontSize: '13px', backgroundColor: '#f7f7f7', outline: 'none', cursor: 'pointer' }}
                >
                    {Object.entries(SORT_BY_OPTIONS).filter(([key, option]) => key !== 'default').map(([key, option]) => (
                        <option key={key} value={key}>{option.displayName}</option>
                    ))}
                </select>
                <button
                    onClick={() => this.setState(s => ({ userSortDir: s.userSortDir === 'asc' ? 'desc' : 'asc' }), () => this.getFilteredUsers({ resetPage: true }))}
                    title={this.state.userSortDir === 'asc' ? 'Ascending' : 'Descending'}
                    style={{ marginLeft: '6px', width: '34px', height: '34px', borderRadius: '5px', border: '1px solid #e3e3e3', backgroundColor: '#f7f7f7', cursor: 'pointer', fontSize: '16px' }}
                >
                    {this.state.userSortDir === 'asc' ? '↑' : '↓'}
                </button>
                </div>
            </div>
            </div>

            <div className={`${Style.workArea}`}>
                <table className="listTable mb-5">
                <thead className="tableHead">
                    <tr>
                    {
                    this.usersGridDef.columns.map((col) => (
                        <th key={col.fieldName} style={{ width: col.width, minWidth: '80px' }} className={col.className}>{col.displayName}</th>
                    ))
                    }
                    </tr>
                </thead>
                <tbody>
                {
                    this.props.usersLoading ?
                    (<tr><td colSpan={this.usersGridDef.columns.length}>
                        <LoaderWrapper loading={this.props.usersLoading} data={this.props.users} waitForData={true} styles={{ minHeight: '380px' }} isFlex={true} placeholderText={"No Records Found"} >
                            </LoaderWrapper>
                    </td></tr>)
                    :
                    this.props.users.length === 0 ?
                    (<tr><td colSpan={this.usersGridDef.columns.length}>
                            <div className={"notFound"} style={{ fontSize: '18px', paddingTop:'20px'}}>
                                <p className={` `}>No Records Found</p>
                            </div>
                        </td>
                    </tr>
                    )
                    :
                    <>
                    {this.props.users?.slice(0, this.state.userFilters.pageSize).map((user) => (
                    <tr key={user.userId}>
                        <td style={{ minWidth: '290px' }}>
                            <div className={Style.boldFont}>{user.userName}</div>
                            <Tooltip id={user.userName} data={user.userName} />
                        </td>
                        <td style={{ minWidth: '350px' }}>
                            <i>
                                Created at{' '}
                                {formatDetectionDatetime(user.CreatedOn)}
                            </i>
                        </td>
                        <td style={{ minWidth: '170px' }}>
                            {user.isActive ? 'Active' : 'Inactive'}
                        </td>
                        <td style={{ minWidth: '50px' }}>
                        <img
                            className="rowDetail"
                            onClick={() => this.onUserActionClick(user)}
                            src={EnterIcon}
                            alt="next-icon"
                        />
                        </td>
                    </tr>
                    ))}
                    </>
                }</tbody>
                </table>
                </div>
                <div className={`d-flex justify-content-center align-items-end`} >
                <Paginator
                    onNext={this.loadNextUsers}
                    onPrev={this.loadPrevUsers}
                    filters={this.getUserFilters({ ...this.state.userFilters, offset: (this.state.userFilters.pageNo - 1) * (this.state.userFilters.pageSize) })}
                    totalSize={this.state.userFilters.pageNo * (this.state.userFilters.pageSize)}
                    isLastPage={this.props.isUsersLastPage}
                    cacheSize={this.props.users.length}
                    from={'UserTab'}
                />
            </div>
        </>
        );
    }
}

const mapStateToProps = (state) => ({
  selectedCustomer: state.entities.customers.selected,
  userStats: state.entities.lmDevicesUsers.userStats,
  userStatsLoading: state.entities.lmDevicesUsers.userStatsLoading,
  users: state.entities.lmDevicesUsers.users,
  usersLoading: state.entities.lmDevicesUsers.usersLoading,
  usersFilters: state.entities.lmDevicesUsers.usersFilters,
  isUsersLastPage: state.entities.lmDevicesUsers.isUsersLastPage,
})

const mapDispatchToProps = (dispatch) => ({
  getLmUsers: (filters, selectedId, defaultCustomerId, isGlobalView) => dispatch(getLmUsers(filters, selectedId, defaultCustomerId, isGlobalView)),
  getUserStats: (selectedId, defaultCustomerId, isGlobalView) => dispatch(getUserStats(selectedId, defaultCustomerId, isGlobalView)),
  selectUsr: (user) => dispatch(selectUsr(user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserTab)
